export default class {

  constructor (selector) {
    this.selector = selector
  }

  init () {
    $('body').on('click', this.selector, (e) => {
      let $el = $(e.currentTarget)
      let key = $el.data('key')
      let $children = $(`.composite-parent-${key}`)
      if ($el.hasClass('is-open')) {
        $children.hide()
        $el.removeClass('is-open')
      } else {
        $children.show()
        $el.addClass('is-open')
      }
    })
  }

}



// WEBPACK FOOTER //
// ./scripts/components/composite-collapse.js